import {cx} from '@local/utils/cx'

import {AboutSplitWords} from './AboutSplitWords'
import {ReactNode} from 'react'

export interface AboutTextProps {
	children: ReactNode
	className?: string
	textClassName?: string
	isSerif?: boolean,
	index: number,
}

export const AboutText = ({children, className, textClassName, isSerif = false, index}: AboutTextProps) => {
	const HeadingTag = index === 0 ? 'h2' : 'h3'

	return (
		<div className={cx(
			'text-white text-center',
			'absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2',
			'grid place-items-center',
			className,
		)}>
			<HeadingTag
				className={cx(
					'text-18 lg:text-24 tracking-tight leading-[1.3]',
					isSerif ? 'font-serif text-28 lg:text-34 leading-snug' : 'font-sans font-[350]',
					textClassName,
				)}>
				<AboutSplitWords>
					{children}
				</AboutSplitWords>
			</HeadingTag>
		</div>
	)
}
